import { useState, useEffect } from 'react';
import { getWindowScrollY } from '../modules/utils';

function getWindowScroll() {
  return {
    scrollY: getWindowScrollY(),
  };
}

// since these run on the client, we shouldn't set any defaults
// until the first render pass has happened, as React will ignore it
// https://github.com/facebook/react/issues/11128

function useWindowScroll() {
  let [windowScroll, setWindowScroll] = useState({ scrollY: undefined });

  function handleScroll() {
    setWindowScroll(getWindowScroll());
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    setTimeout(() => {
      handleScroll();
    }, 0);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return windowScroll;
}

export default useWindowScroll;
